import React, {useEffect, useState} from 'react';
import Select from './pages/Select';
import instance from './apis';
import ChartView from './ChartView';
import Qualities from './pages/Qualities';
import {Grid} from "@material-ui/core";
import load from './load.gif';

const App = () => {
    const [wait, setWait] = useState({brand: false, model: false, year: false, engine: false, stage: false})
    const [config, setConfig] = useState({currency: "€", quality_status: -1});
    const [lang, setLang] = useState({});
    const [brands, setBrands] = useState([]);
    const [priceSet, setPriceSet] = useState({s0: 1, s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, func: "*"});
    const [hpSet, setHpSet] = useState({s0: 1, s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, func: "*"});
    const [nmSet, setNmSet] = useState({s0: 1, s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, func: "*"});
    const [models, setModels] = useState([]);
    const [years, setYears] = useState([]);
    const [engines, setEngines] = useState([]);
    const [stages, setStages] = useState([]);
    const [url, setUrl] = useState(window.location.hash)
    const [title, setTitle] = useState('Chip Tuning')
    const [qualities, setQualties] = useState([])

    const [, setBrand] = useState([]);
    const [, setModel] = useState([]);
    const [, setYear] = useState([]);
    const [, setEngine] = useState([]);
    const [stage, setStage] = useState([]);

    const [brandId, setBrandId] = useState(undefined);
    const [modelId, setModelId] = useState(undefined);
    const [yearId, setYearId] = useState(undefined);
    const [engineId, setEngineId] = useState(undefined);
    const [stageId, setStageId] = useState(undefined);
    const [view, setView] = useState("none")

    function idSelector(str) {
        return str.split("-")[0]
    }

    window.location.hash = url;
    document.title = title;
    useEffect(() => {
        setWait({brand: true})
        instance
            .get('/chiptuning')
            .then(function (res) {
                setWait({brand: false})
                setBrands(res.data)
            })
        instance
            .get('/languages/chiptuning')
            .then(function (res) {
                setLang(res.data)
            })
        instance
            .get('/config')
            .then(function (res) {
                setConfig(res.data)
            })
    }, [])
    useEffect(() => {
        if (url) {
            const urlExp = url.split("/")
            const urlCount = urlExp.length
            if (urlCount == 1 && brands.length < 1) {
                const id = idSelector(urlExp[0]).replace('#', '')
                getModelFunc(id)
            } else if (urlCount == 2 && models.length < 1) {
                getModelFunc(idSelector(urlExp[0]).replace('#', ''))
                getYearFunc(idSelector(urlExp[1]))
            } else if ((urlCount == 3 && years.length < 1)) {
                getModelFunc(idSelector(urlExp[0]).replace('#', ''))
                getYearFunc(idSelector(urlExp[1]))
                getEngineFunc(idSelector(urlExp[2]))
            } else if ((urlCount == 4 && engines.length < 1)) {
                getModelFunc(idSelector(urlExp[0]).replace('#', ''))
                getYearFunc(idSelector(urlExp[1]))
                getEngineFunc(idSelector(urlExp[2]))
                getStageFunc(idSelector(urlExp[3]))
            }
        }

    }, [brands])

    const getModelFunc = (id, urlConf = false) => {
        try {
            setWait({model: true});
            const brandData = brands.find(data => data.id == id)
            setBrand(brandData)
            setBrandId(id)
            setModelId(undefined)
            setYearId(undefined)
            setEngineId(undefined)
            setStageId(undefined)
            setModels([])
            setYears([])
            setEngines([])
            setStages([])
            setView("none")
            instance
                .get(`/tuning/models/${id}`)
                .then(function (res) {
                    setModels(res.data)
                    setTitle(res.data[0].parent.var_title + " | Chip Tuning")
                    setWait({model: false});

                })
                .then(
                    function () {
                        if (urlConf) {
                            setUrl(brandData.seo_url)
                        }
                    }
                )
        } catch (e) {

        }

    }
    const getYearFunc = (id, urlConf = false) => {
        try {
            setWait({year: true});
            const modelData = models.find(data => data.id == id)
            setModel(modelData)
            setModelId(id)
            setYearId(undefined)
            setEngineId(undefined)
            setStageId(undefined)
            setYears([])
            setEngines([])
            setStages([])
            setView("none")

            instance
                .get(`/tuning/years/${id}`)
                .then(function (res) {
                    setYears(res.data)
                    setTitle(res.data[0].parent.seo_title + " | Chip Tuning")
                    setWait({year: false});

                })
                .then(
                    function () {
                        if (urlConf) {
                            setUrl(modelData.seo_url)
                        }
                    })
        } catch (e) {

        }
    }
    const getEngineFunc = (id, urlConf = false) => {
        try {
            setWait({engine: true});
            const yearData = years.find(data => data.id == id)
            setYear(yearData)
            setYearId(id)
            setEngineId(undefined)
            setStageId(undefined)
            setEngines([])
            setStages([])
            setView("none")

            instance
                .get(`/tuning/engines/${id}`)
                .then(function (res) {
                    setEngines(res.data)
                    setTitle(res.data[0].parent.seo_title + " | Chip Tuning")
                    setWait({engine: false});
                }).then(
                function () {
                    if (urlConf) {
                        setUrl(yearData.seo_url)
                    }
                })

        } catch (e) {

        }
    }

    function getStageFunc(id, urlConf = false) {
        try {
            setWait({stage: true});
            const engineData = engines.find(data => data.id == id)
            setEngine(engineData)
            setEngineId(id)
            setStageId(undefined)
            setStages([])
            setView()
            instance
                .get(`/tuning/bulk/option`)
                .then(result => {
                    if (result.data) {
                        if (result.data[1]) {
                            setPriceSet(result.data[1])
                        }
                        if (result.data[2]) {
                            setHpSet(result.data[2])
                        }
                        if (result.data[3]) {
                            setNmSet(result.data[3])
                        }
                        if (result.data['qualities']) {
                            setQualties(result.data['qualities'])
                        }
                    }
                    setWait({stage: false});
                });
            instance
                .get(`/tuning/stages/${id}`)
                .then(function (res) {
                        setStages(res.data);
                        setTitle(res.data[0].parent.seo_title + " | Chip Tuning")
                        if (res.data[1]) {
                            setStage(res.data[1]);
                            setStageId(res.data[1].id);
                        } else {
                            setStage(res.data[0]);
                            setStageId(res.data[0].id);
                        }
                    }
                ).then(
                function () {
                    if (urlConf) {
                        setUrl(engineData.seo_url)
                    }
                })
        } catch (e) {

        }
    }

    const getModels = (event) => {
        const id = event.target.value
        getModelFunc(id, true)
    }
    const getYears = (event) => {
        const id = event.target.value
        getYearFunc(id, true)
    }
    const getEngines = (event) => {
        const id = event.target.value
        getEngineFunc(id, true)
    }
    const getStages = (event) => {
        const id = event.target.value
        getStageFunc(id, true)
    }
    const Logo = ({logo}) => {
        if (logo.indexOf('http') != -1) {
            return <img width={60} src={logo}/>
        }
        return (
            <img width={60} src={`https://api.carecusoft.com/userfiles/${logo}`}/>
        )
    }
    const BrandInfo = () => {
        if (stageId) {
            const brand = stage.parent.parent.parent.parent;
            const engine = stage.parent;
            return (
                <div style={{height: 88}} className="acr-2 acr-border acr-radius acr-p-10 acr-m-10 cst-2-standart acr-shadow">
                    <div className="acr-s-div">
                        <div className="acr-s-1">
                            <Logo logo={brand.my_data != null ? brand.my_data.logo : brand.var_logo_big}/>
                        </div>
                        <div className="acr-s-3 acr-m-4">
                            <div className="acr-h18">
                                <b>{lang.standart ? lang.standart : 'STANDART'}</b>
                                <br/>
                            </div>
                            <div className="acr-s-div">
                                <div className="acr-s-1 acr-h16">
                                    <b>{engine.my_data != null ? engine.my_data.hp : engine.int_hp}</b> <span className="acr-h12">hp</span>

                                </div>
                                <div className="acr-s-1 acr-h16">
                                    <b>{engine.my_data != null ? engine.my_data.nm : engine.int_nm}</b> <span className="acr-h12">nm</span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <></>
        }

    }
    const dataFunc = (func, rate, data) => {
        data = Number(data);
        rate = Number(rate);
        switch (func) {
            case "*":
                return data * rate;
                break
            case "+":
                return data + rate;
                break
            case "-":
                return data - rate;
                break
            case "/":
                if (rate == 0) {
                    return data;
                }
                return data / rate;
                break
            case "=":
                return rate;
                break
        }
    }
    const NmStage = (getData) => {
        const nmPer = getData.nmPer
        const newNm = dataFunc(nmSet.func, nmPer, getData.data.int_nm_new);
        const nmDiff = newNm - getData.data.parent.int_nm;
        return (
            <div className="acr-s-1 acr-h16">
                <b>{getData.data.my_data != null ? getData.data.my_data.nm : newNm}</b> <span className="acr-h14">nm</span>
                <div className="acr-both"></div>
                <span className="acr-h16 cst-2-diff"><b>+{getData.data.my_data != null ? getData.data.my_data.nm_diff : nmDiff}</b> <span className="acr-h12">nm</span></span>
            </div>
        )
    }
    const Stage = ({data}) => {
        let pricePer = 1;
        let nmPer = 1;
        let hpPer = 1;
        switch (data.stage_type) {
            case 0:
                pricePer = priceSet.s0
                hpPer = hpSet.s0
                nmPer = nmSet.s0
                break
            case 1:
                pricePer = priceSet.s1
                hpPer = hpSet.s1
                nmPer = nmSet.s1
                break
            case 2:
                pricePer = priceSet.s2
                hpPer = hpSet.s2
                nmPer = nmSet.s2
                break
            case 3:
                pricePer = priceSet.s3
                hpPer = hpSet.s3
                nmPer = nmSet.s3
                break
            case 4:
                pricePer = priceSet.s4
                hpPer = hpSet.s4
                nmPer = nmSet.s4
                break
            case 5:
                pricePer = priceSet.s5
                hpPer = hpSet.s5
                nmPer = nmSet.s5
                break
            default:
                pricePer = 1;
                hpPer = 1
                nmPer = 1
        }
        if (data.stage_type == 0) {
            return (
                <></>
                /* <div key={data.id} id={data.id} className={`acr-2 acr-border acr-radius acr-p-10 acr-m-10 cst-2-tuning-${data.stage_type} acr-shadow`}>
                     <div className="acr-s-div" style={{position: 'relative'}}>
                         <div className="acr-s-1 acr-m-4 ">
                             <div className="acr-h18">
                                 <b>{data.my_data != null ? data.my_data.name : data.var_title}</b>
                             </div>
                             <NmStage data={data}/>
                         </div>
                         <div className="acr-s-1 acr-h16">
                             <span style={{color: '#7FB800'}} className=" cst-2-diff"><b>-{data.my_data != null ? data.my_data.eco : data.int_eco}</b> <span className="acr-h12">FUEL</span></span>
                         </div>
                         <div className="cst-2-price">{
                             data.my_data != null ? data.my_data.eco :
                                 config.currency != -1 ? `${data.price * pricePer} ${config.currency}` : ''
                         }

                         </div>
                     </div>
                 </div>*/
            )
        } else {
            const Fuel = () => {
                if (data.int_eco) {
                    return (
                        <div className="acr-s-1 acr-h16">
                                <span style={{color: '#7FB800'}} className=" cst-2-diff">
                                    <b>-%{data.my_data != null ? data.my_data.eco : data.int_eco}</b>
                                    <span className="acr-h12"> FUEL</span>
                                </span>
                        </div>
                    )
                } else {
                    return <></>
                }
            }
            const newHp = dataFunc(hpSet.func, hpPer, data.int_hp_new);
            const newPrice = dataFunc(priceSet.func, pricePer, data.price);
            const hpDiff = newHp - data.parent.int_hp;
            return (
                <div key={data.id} id={data.id} className={`acr-2 acr-border acr-radius acr-p-10 acr-m-10 cst-2-tuning-${data.stage_type} acr-shadow`}>
                    <div className="acr-s-div" style={{position: 'relative'}}>
                        <div className="acr-s-1 acr-m-4">
                            <div className="acr-s-div">
                                <div className="acr-s-1">
                                    <div className="acr-h18">
                                        <b>{data.my_data != null ? data.my_data.name : data.var_title}</b>
                                        <br/>
                                    </div>
                                </div>
                                <Fuel/>
                            </div>
                            <div className="acr-s-div">
                                <div className="acr-s-1 acr-h16">
                                    <b>{data.my_data != null ? data.my_data.hp : newHp}</b> <span className="acr-h12">hp</span>
                                    <div className="acr-both"></div>
                                    <span className="cst-2-diff"><b>+{data.my_data != null ? data.my_data.hp_diff : hpDiff}</b> <span className="acr-h12">hp</span></span>
                                </div>
                                <NmStage data={data} nmPer={nmPer}/>
                            </div>
                        </div>
                        <div className="cst-2-price">
                            {
                                config ?
                                    config.currency != undefined && config.currency != "-1" ?
                                        data.my_data != null ?
                                            `${data.my_data.price}${config.currency}` :
                                            `${newPrice}${config.currency}`
                                        : ''
                                    : `${newPrice}€`
                            }
                        </div>
                    </div>
                </div>
            )
        }
    }
    const StagesView = () => {
        return stages.map((data) => (
            <Stage key={data.id} data={data}/>
        ))
    }

    const QualityView = () => {
        if (config.quality_status == 1) {
            return <div className="acr-1 acr-shadow acr-border acr-m-10  acr-p-10 acr-radius ">
                <Qualities qualities={qualities}/>
            </div>
        } else {
            return <></>
        }
    }
    const FooterView = () => {
        if (wait.stage) {
            return <Grid container justify={"center"} alignItems={"center"} alignContent={"center"}><img style={{border: "none"}} src={load}/> </Grid>
        }
        return <div className="acr-div " style={{display: view}}>
            <QualityView/>
            <div className="acr-1 acr-shadow  acr-border acr-m-10 acr-p-10 acr-radius acr-align-items-start">
                <ChartView stages={stages}/>
            </div>
        </div>
    }
    return (
        <div>
            <div className="acr-div acr-shadow acr-p-10 acr-radius">
                <div className="acr-1 acr-m-10 carecut-2">
                    {lang.brands}
                    <Select datas={brands} lang={lang} id={brandId} handleChange={getModels} wait={wait.brand}/>
                </div>
                <div className="acr-1  acr-m-10 carecut-2">
                    {lang.models}
                    <Select datas={models} lang={lang} id={modelId} handleChange={getYears} wait={wait.model}/>
                </div>
                <div className="acr-1  acr-m-10 carecut-2">
                    {lang.years}
                    <Select datas={years} lang={lang} id={yearId} handleChange={getEngines} wait={wait.year}/>
                </div>
                <div className="acr-1  acr-m-10 carecut-2">
                    {lang.engines}
                    <Select datas={engines} lang={lang} id={engineId} engine={1} handleChange={getStages} wait={wait.engine}/>
                </div>
            </div>
            <div className="acr-div " style={{marginTop: 30}}>
                <BrandInfo/>
                <StagesView/>
            </div>
            <FooterView/>
        </div>
    );
}

export default App;
